export const logosGrid = () => {
  const logosGrids = document.querySelectorAll('.logos-grid--grid');

  if (logosGrids) {
    const logos = document.querySelectorAll('.logos-grid--logo img');

    if (logos) {
      let logosLoaded = 0;

      [...logos].forEach((logo) => {
        logo.addEventListener("load", () => {
          createMasonry(logosGrids);
        });
      });
    }

    window.addEventListener("load", () => {
      createMasonry(logosGrids);
    });
    window.addEventListener("resize", () => {
      createMasonry(logosGrids);
    });
  }
};

function createMasonry(grids) {
  [...grids].forEach((grid) => {
    let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));

    const gridItems = grid.querySelectorAll('.logos-grid--item');

    if (gridItems) {
      [...gridItems].forEach((item) => {
        let rowSpan = Math.ceil((item.querySelector('.logos-grid--content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

        item.style.gridRowEnd = 'span ' + rowSpan;
      });
    }
  });
}
